import { render, staticRenderFns } from "./order-cancel.vue?vue&type=template&id=b96ba75c&"
import script from "./order-cancel.vue?vue&type=script&lang=js&"
export * from "./order-cancel.vue?vue&type=script&lang=js&"
import style0 from "./order-cancel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports